import React, { useState, useEffect } from "react";
import TetrisGame from "../games/components/TetrisGame";
import SnakeGame from "../games/components/SnakeGame";
import Board from "../games/components/MineSweeper/Board";
import WhackaMole from "../games/components/WhackaMole/WhackaMole";
import BoardView from "../games/components/2048/BoardView";
import Popup from './Popup';
import "../stylesheet/Games.css";

export default function Games() {
  
  const [isOpen, setIsOpen] = useState(false);
  const [game, setGame] = useState(<Games />);
 
  const togglePopup = (gameType) => {
    // The close-icon in Popup calls this with 'close', which used to fall
    // into the else branch and do a full window.location.reload() instead
    // of actually closing the popup - that's what made the close button
    // look like it did nothing (or flashed/reloaded instead of closing).
    if(gameType == 'close') {
      setIsOpen(false);
      return;
    }
    if(gameType == 'tetris') {
      setGame(<TetrisGame />);
    } else if(gameType == 'whackamole') {
      setGame(<WhackaMole />);
    } else if(gameType == 'snake') {
      setGame(<SnakeGame color="#248ec2" />);
    } else if(gameType == 'minesweeper') {
      setGame(<Board />);
    } else if(gameType == '2048') {
      setGame(<BoardView />);
    }
    setIsOpen(true);
  }

  useEffect(() => {
    const close = (e) => {  
      if(e.keyCode === 27){
        setIsOpen(false);
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  },[])

    return (
      <div className='base'>
        <div className='main-content-outer'>
        <h1 className="sr-only">Games</h1>
        <span className="page-watermark" aria-hidden="true">Games</span>
        <div className="gameMainContainer">
          {isOpen && <Popup content={game} handleClose={() => togglePopup('close')}/>}
            <div className="gameCard">
                <img src="assets/tetris.png" alt="Tetris Game" />
                <div className="gameContainer">
                    <div className="gameDetails">
                      <h4><b>Tetris Game</b></h4>
                      <input type="button" value="PLAY NOW" onClick={() => togglePopup('tetris')}/>
                    </div>
                </div>
            </div>
            <div className="gameCard">
                <img src="assets/whackamole.png" alt="Whack a Mole" />
                <div className="gameContainer">
                    <div className="gameDetails">
                      <h4><b>Whack a Mole</b></h4>
                      <input type="button" value="PLAY NOW" onClick={() => togglePopup('whackamole')}/>
                    </div>
                </div>
            </div>
            { window.innerWidth > 800 ? <div className="gameCard">
                <img src="assets/snake.webp" alt="Snake Game" />
                <div className="gameContainer">
                    <div className="gameDetails">
                      <h4><b>Snake Game</b></h4>
                      <input type="button" value="PLAY NOW" onClick={() => togglePopup('snake')}/>
                    </div>
                  </div>
            </div> : ''}
            <div className="gameCard">
                <img src="assets/minesweeper.png" alt="Minesweeper" />
                <div className="gameContainer">
                    <div className="gameDetails">
                      <h4><b>Minesweeper</b></h4>
                      <input type="button" value="PLAY NOW" onClick={() => togglePopup('minesweeper')}/>
                    </div>
                  </div>
            </div>
            <div className="gameCard">
                <img src="assets/2048.png" alt="2048" />
                <div className="gameContainer">
                    <div className="gameDetails">
                      <h4><b>2048</b></h4>
                      <input type="button" value="PLAY NOW" onClick={() => togglePopup('2048')}/>
                    </div>
                </div>
            </div>
        </div>
        </div>
      </div>
    );
}